export default {
  props: {
    classes: {
      type: Array,
      default: () => []
    }
  }
};